<template>
  <Dialog
    v-model="dialog"
    :title="'削除'"
    textNo="いいえ"
    textYes="はい"
    colorTextYes="red--text"
  >
    <template v-slot:activator="{ on }">
      <v-icon size="medium" v-on="on" class="mr-1 ml-3"
        >fas fa-trash-alt</v-icon
      >
    </template>
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn color @click="dialog = false" small>キャンセル</v-btn>
      <v-btn
        color="error"
        @click="handleDelete"
        small
        :loading="loading"
        :disabled="loading"
        >OK</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
// import { deleteVocabulary } from "@/api/Vocabulary.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["index"],
  components: { Dialog },
  store: ["vocabularyGrammar"],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
    handleDelete() {
      this.$delete(this.vocabularyGrammar, this.index);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>